import { useContext, useEffect, useState } from "react";
import { Avatar, Button, CssBaseline, TextField, Box, Typography, Container, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, CircularProgress, useMediaQuery, Menu, MenuItem, Divider } from '@mui/material'
import { Visibility, VisibilityOff, Email as EmailIcon, Lock as LockIcon, Settings as SettingsIcon, Google as GoogleIcon } from "@mui/icons-material";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from "react-i18next";
import { AuthContext } from 'context/AuthContext'
import ValidationSchema from "./services/SchemaValidation"
import { SnackbarGlobal } from 'components/Snackbar'
import { useMutation } from "react-query";
import { login, loginGoogleAuth } from "./services/api/Auth";
import { Link, useNavigate } from 'react-router-dom'
import i18n from "i18next";
import { auth, signInWithGoogle } from "../../firebase";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";

export default function Login() {
  const { t } = useTranslation();
  const mdMQ = useMediaQuery(theme => theme.breakpoints.up('md'));
  const { activateAuth, loadUser, loadToken, isAuth } = useContext(AuthContext)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [recaptcha, setRecaptcha] = useState(null);
  let { handleSubmit, register, formState: { errors } } = useForm({ resolver: yupResolver(ValidationSchema) })

  useEffect(() => {
    if (isAuth) { navigate("/admin/dashboard") }
  })

  const mutation = useMutation(login, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        setMessageSnackbar('Correo y/o contraseña incorrectos');
        setAuthError(true);
      } else {
        loadUser(JSON.stringify(data.user))
        loadToken(data.token)
        activateAuth()
        if (data.user.company) {
          navigate("/admin/dashboard")
        } else {
          //navigate("/admin/account")
          console.log("login data.user.stripe_suscription_id", data.user.stripe_suscription_id)
          if(data.user.stripe_suscription_id !== null && data.user.stripe_suscription_id !== undefined && data.user.stripe_suscription_id !== "") {
            navigate("/admin/account")
          } else {
            navigate("/admin/account")
          }
        }
      }
    }
  })

  const mutationGoogle = useMutation(loginGoogleAuth, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error" || data.status === "user_not_exist") {
        setMessageSnackbar('Correo y/o contraseña incorrectos');
        setAuthError(true);
      } else {
        loadUser(JSON.stringify(data.user))
        loadToken(data.token)
        activateAuth()
        if (data.user.company) {
          navigate("/admin/dashboard")
        } else {
          //navigate("/admin/account")
          console.log("google data.user.stripe_suscription_id", data.user.stripe_suscription_id)
          if(data.user.stripe_suscription_id !== null && data.user.stripe_suscription_id !== undefined && data.user.stripe_suscription_id !== "") {
            navigate("/admin/account")
          } else {
            navigate("/admin/account")
          }
        }
      }
    }
  })

  const onSubmit = (params) => { //console.log("Params:", JSON.stringify(params))
    if (recaptcha == null) {
      setMessageSnackbar('Es necesario marcar el captcha');
      setAuthError(true); return;
    }
    setIsLoading(true)
    mutation.mutate(params)
  }

  const onSubmitGoogle = async () => {
    await signInWithGoogle()
    auth.currentUser.getIdToken().then(async (idToken) => {
      console.log(idToken)
      setIsLoading(true)
      mutationGoogle.mutate({ idToken: idToken })
      /* let loginGoogleRes = await loginGoogleAuth({ idToken: idToken })
      console.log("loginGoogleRes", loginGoogleRes) */
    }).catch(function (error) {
      console.error(error);
    });
  }

  const handleClickShowPassword = () => { setShowPassword(!showPassword) }
  const handleMouseDownPassword = (event) => { event.preventDefault() }
  function onChangeRecaptcha(value) { setRecaptcha(value) }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => { setAnchorEl(event.currentTarget); };
  const handleClose = () => { setAnchorEl(null); };

  const changeLanguage = (lng) => { i18n.changeLanguage(lng); }

  return (<FMPageOpacityTransition>
    <Container style={{ maxWidth: "100%", paddingLeft: 0, paddingRight: 0, height: "100vh" }}>
      <CssBaseline />
      <div style={{ display: "grid", gridTemplateColumns: mdMQ ? "1.35fr 2fr" : "1fr", gap: 0 }}>
        {mdMQ ?
          <div style={{ height: "100vh", background: "url(/login-carousel-1.jpg)", backgroundEepeat: "no-repeat", backgroundSize: "cover", position: "sticky", top: 0 }}></div>
          : null}
        <Box sx={{ padding: 3 }} >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "end", marginBottom: 16 }}>
            <div>
              No tienes cuenta? &nbsp; <Button variant="outlined" component={Link} to="/registro">Regístrate</Button>
            </div>
            <div style={{ textAlign: "right" }}>
              <IconButton
                onClick={handleClick}
                size="small"
                color="inherit"
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                <SettingsIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 12,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                {i18n.language === "en" ?
                  <MenuItem onClick={() => changeLanguage('es')}>
                    <Avatar alt="Spanish" src="/spanish_flat.png" /> Español
                  </MenuItem>
                  : null}
                {i18n.language === "es" ?
                  <MenuItem onClick={() => changeLanguage('en')}>
                    <Avatar alt="English" src="/english_flat.png" /> Inglés
                  </MenuItem>
                  : null}
              </Menu>
            </div>
          </div>
          <div style={{ maxWidth: 403, margin: "0 auto" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar sx={{ m: 1, bgcolor: "primary.main" }}> <QrCodeIcon /> </Avatar>
              <Typography component="h1" variant="h5" sx={{ fontWeight: "bold", fontSize: 30 }}> {t("login_page_title")} </Typography>
            </div>
            <Typography component="p" variant="body1"> {t("login_page_subtitle")} </Typography>
            {!isLoading ?
              <Button onClick={onSubmitGoogle} fullWidth variant="contained" color="primary" style={{ marginTop: 16, marginBottom: 16 }}>
                <GoogleIcon /> &nbsp; {t("login_form_signin_google_button")}
              </Button>
              : <div style={{ display: "flex", justifyContent: "center", marginTop: 10, marginBottom: 10 }}> <CircularProgress /> </div>}
            <Divider>{t("login_form_divider_options")}</Divider>
            <Box sx={{ mt: 2 }}>
              <InputLabel htmlFor="email" required style={{ fontSize: 16 }}>{t("login_form_email")}</InputLabel>
              <TextField required fullWidth autoFocus margin="normal" size="small" name="email"
                {...register("email")}
                error={errors.email ? true : false}
                style={{ marginTop: 8 }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><EmailIcon fontSize="small" /></InputAdornment>,
                }}
              />
              <InputLabel htmlFor="password" required style={{ fontSize: 16, marginTop: 14 }}>{t("login_form_password")}</InputLabel>
              <FormControl variant="outlined" fullWidth margin="normal" required style={{ marginTop: 8, marginBottom: 16 }}>
                <OutlinedInput required fullWidth size="small"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  {...register("password")}
                  error={errors.password ? true : false}
                  startAdornment={<InputAdornment position="start"><LockIcon fontSize="small" /></InputAdornment>}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" edge="end"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      > {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />} </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <br /> <ReCAPTCHA id="recaptcha" sitekey="6LemSy8bAAAAABqOAmOu9I6-L2ME8FPAm0ogNcA2" onChange={onChangeRecaptcha} hl="en" /> <br />
              {(recaptcha !== null) && <>
                {!isLoading ?
                  <Button onClick={handleSubmit(onSubmit)} fullWidth variant="contained" color="primary"> {t("login_form_button")} </Button>
                  : <div style={{ display: "flex", justifyContent: "center", marginTop: 10, marginBottom: 10 }}> <CircularProgress /> </div>}
              </>}
            </Box>
          </div>
        </Box>
      </div>
    </Container>
    <SnackbarGlobal vertical='bottom' horizontal='center' open={authError} close={() => setAuthError(false)} message={messageSnackbar} />
  </FMPageOpacityTransition>);
}